"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toKebabCase = void 0;
const toKebabCase = (text) => text.replace(/([a-z])([A-Z])/g, '$1-$2');
exports.toKebabCase = toKebabCase;
//# sourceMappingURL=caseFormatConverter.js.map